module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_address.title')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.address')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.address_th'),
      "placeholder": _vm.$t('message.clinic_address.address_th')
    },
    model: {
      value: (_vm.clinic.th.b_addr),
      callback: function($$v) {
        _vm.clinic.th.b_addr = $$v
      },
      expression: "clinic.th.b_addr"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.address_en'),
      "placeholder": _vm.$t('message.clinic_address.address_en')
    },
    model: {
      value: (_vm.clinic.en.b_addr),
      callback: function($$v) {
        _vm.clinic.en.b_addr = $$v
      },
      expression: "clinic.en.b_addr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "provice"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_address.province')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "provice",
      "placeholder": _vm.$t('message.clinic_address.province'),
      "options": _vm.refProvinces,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selectedProvince),
      callback: function($$v) {
        _vm.selectedProvince = $$v
      },
      expression: "selectedProvince"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "district"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_address.district')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "district",
      "placeholder": _vm.$t('message.clinic_address.district'),
      "options": _vm.refDistricts,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selectedDistrict),
      callback: function($$v) {
        _vm.selectedDistrict = $$v
      },
      expression: "selectedDistrict"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.insurances')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "insurances",
      "placeholder": _vm.$t('message.clinic_address.insurances'),
      "options": _vm.allInsurances,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.selectedInsurance),
      callback: function($$v) {
        _vm.selectedInsurance = $$v
      },
      expression: "selectedInsurance"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.contact_info')))]), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.email'),
      "placeholder": _vm.$t('message.clinic_address.email')
    },
    model: {
      value: (_vm.clinic.clinic_email),
      callback: function($$v) {
        _vm.clinic.clinic_email = $$v
      },
      expression: "clinic.clinic_email"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.website'),
      "placeholder": _vm.$t('message.clinic_address.website')
    },
    model: {
      value: (_vm.clinic.website),
      callback: function($$v) {
        _vm.clinic.website = $$v
      },
      expression: "clinic.website"
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": _vm.$t('message.clinic_address.facebook'),
      "placeholder": _vm.$t('message.clinic_address.facebook')
    },
    model: {
      value: (_vm.clinic.facebook),
      callback: function($$v) {
        _vm.clinic.facebook = $$v
      },
      expression: "clinic.facebook"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_address.clinic_map')))]), _vm._v(" "), _c('gmap-autocomplete', {
    staticClass: "place-input form-control",
    attrs: {
      "placeholder": _vm.$t('message.clinic_address.nearby_search'),
      "select-first-on-enter": true
    },
    on: {
      "place_changed": function($event) {
        _vm.updatePlace($event)
      }
    }
  }), _vm._v(" "), _c('google-map', {
    attrs: {
      "center": _vm.mapCenter,
      "map-type-id": "terrain",
      "zoom": 15
    },
    on: {
      "update:center": function($event) {
        _vm.mapCenter = $event
      }
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.markPosition,
      "clickable": true,
      "draggable": true
    },
    on: {
      "update:position": function($event) {
        _vm.markPosition = $event
      },
      "dragend": _vm.setPosition
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-698c08ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/Address.vue
// module id = 1027
// module chunks = 1